import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useDebounce from "src/hooks/useDebounce";

export default function useTaskFormAutoSave(isDisabled?: boolean) {
	const { actions, changes, status } = useTaskForm();

	useDebounce(changes, 500, () => {
		if (Object.keys(changes).length && status === "idle" && !isDisabled) {
			actions.save({
				disableAlert: true,
			});
		}
	});
}
